import { IndicatorApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { Indicator } from './types';

export const normalizeIndicators = (data: IndicatorApi[]): Indicator[] =>
  data.map((d) => normalizeIndicator(d));

export const normalizeIndicator = (row: IndicatorApi): Indicator => {
  return { ...row, uuid: uuidv4() };
};
